export default __webpack_public_path__ + "static/media/linked-in-logo.c0758ded.svg";